import React from 'react';
import { connect } from 'react-redux';
import DropMenu from '@roo/roo/DropMenu';
import Icon from '@roo/roo/Icon';
import { setStorage } from '@utils/localStorage';
import pageJump from '@projects/Shell/utils/pageJump';

import { RootState } from '../../../../store';
import doLogout from '../../../../utils/doLogout';

import styles from './AcctInfo.module.scss';

const { useState } = React;

type AccInfoProps = {
    /** 用户名 */
    acctName: string;
    /** 是否绑定手机 */
    hasBoundPhone: boolean;
};

const { useCallback } = React;

const AcctInfo: React.FC<AccInfoProps> = ({ acctName, hasBoundPhone }) => {
    /** 菜单展开状态 */
    const [menuVisible, setMenuVisible] = useState(false);

    const clickHandler = useCallback(index => {
        pageJump.go('/new_fe/business#/shop/accountSettings');
        setStorage('accountSettingStep', index);
    }, []);

    const menuRender = () => {
        return (
            <div className={styles.dropMenu}>
                <div className={styles.jumpActList}>
                    <li className={styles.jumpAct} onClick={() => clickHandler(1)}>
                        修改密码
                    </li>
                    {hasBoundPhone ? (
                        <li className={styles.jumpAct} onClick={() => clickHandler(2)}>
                            修改手机
                        </li>
                    ) : null}
                    {!hasBoundPhone ? (
                        <li className={styles.jumpAct} onClick={() => clickHandler(3)}>
                            绑定手机
                        </li>
                    ) : null}
                </div>
                <hr />
                <li className={styles.buttonLogout} onClick={() => doLogout()}>
                    <i className="iconfont icon-wmbpower-off" />
                    退出
                </li>
            </div>
        );
    };

    return (
        <div>
            <DropMenu
                placement="bottom"
                menuComponent={menuRender()}
                trigger="hover"
                flip={false}
                onVisibleChange={status => {
                    setMenuVisible(status);
                }}
            >
                <div className={styles.menuContainer}>
                    <span className={styles.txt}>{acctName}</span>
                    <Icon name={menuVisible ? 'chevron-up' : 'chevron-down'} size={12} />
                </div>
            </DropMenu>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        acctName: state.shellCommon.acctName,
        hasBoundPhone: state.shellCommon.hasBoundPhone,
    };
};

export default connect(mapStateToProps)(AcctInfo);
